<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  size: "sm" | "lg";
}>();

const classes = computed<string[]>(() => [
  "promotion-highlight",
  `promotion-highlight--${props.size}`
]);
</script>

<template>
  <div :class="classes">
    <slot />
  </div>
</template>

<style lang="less" scoped>
.promotion-highlight {
  padding-top: 89px;
  background-repeat: no-repeat;
  text-align: start;

  &--sm {
    width: 393px;
    height: 279px;
    background-image: url(data:image/svg+xml,%3Csvg%20width%3D%22393%22%20height%3D%22279%22%20viewBox%3D%220%200%20393%20279%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20opacity%3D%22.1%22%20d%3D%22M1%20165C-6%20106%2016%2049%2054%2044c37-6%2062%2027%20151-27%20110-67%20195%2080%20187%20145-7%2064-145%20116-256%20117S8%20224%201%20165Z%22%20fill%3D%22%23007DC6%22%2F%3E%3C%2Fsvg%3E%0A);
    background-size: 393px;
  }

  &--lg {
    width: 465px;
    height: 352px;
    background-image: url(data:image/svg+xml,%3Csvg%20width%3D%22490%22%20height%3D%22352%22%20viewBox%3D%220%200%20490%20352%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20opacity%3D%22.1%22%20d%3D%22M2%20208C-7%20134%2020%2062%2067%2055s78%2034%20188-33c138-85%20244%20100%20234%20182S308%20350%20170%20352C31%20354%2010%20283%202%20208Z%22%20fill%3D%22%23007DC6%22%2F%3E%3C%2Fsvg%3E);

    background-size: 465px;
  }
}
</style>
